import { render, staticRenderFns } from "./ShowPlot.vue?vue&type=template&id=5bfe0054"
import script from "./ShowPlot.vue?vue&type=script&lang=js"
export * from "./ShowPlot.vue?vue&type=script&lang=js"
import style0 from "./ShowPlot.vue?vue&type=style&index=0&id=5bfe0054&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports